import groupsActionCreators, { actionTypes } from './groupsActions';

export default groupsActionCreators;
export { actionTypes };
